import { NoLocations } from "./NoLocations";

export default NoLocations;
